if (!customElements.get('nuer-review-conveyor')) {
  customElements.define('nuer-review-conveyor', class extends HTMLElement {
    connectedCallback() {
      if (this.resizeObserver) return;
      this.playback = window.NuerReviewMotion.observePlayback(this);
      this.cleanupHover = window.NuerReviewMotion.observeCardHover(this, '.nuer-reviews__card');
      this.refresh = () => {
        const group = this.querySelector('.nuer-reviews__group');
        const card = group?.querySelector('.nuer-reviews__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(group).columnGap) || 0;
        const duration = window.NuerReviewMotion.duration(this, group.getBoundingClientRect().width,
          card.getBoundingClientRect().width, gap);
        const value = `${duration}s`;
        if (this.style.getPropertyValue('--nuer-home-review-duration') !== value) {
          this.style.setProperty('--nuer-home-review-duration', value);
        }
      };
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.resizeObserver.observe(this);
      const group = this.querySelector('.nuer-reviews__group');
      if (group) this.resizeObserver.observe(group);
      this.refresh();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.cleanupHover?.();
      this.playback?.disconnect();
    }
  });
}
